// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"db725fa5","239":"30b8d014","455":"cd2f0d05"}[chunkId] + ".chunk.js";
};